import { FC } from "react";
import "./App.css";
import "bulma/css/bulma.min.css";
import { QueryClientProvider } from "react-query";
import { ChakraProvider } from "@chakra-ui/react";

// import CustomersPage from "./pages/dashboard/customers/Index";
import queryClient from "./infrastructure/reactQuery";
import Pages from "./pages/Index";

const App: FC = () => (
  <ChakraProvider>
    <QueryClientProvider client={queryClient}>
      <div className="section">
        <div className="container is-max-desktop">
          <Pages />
        </div>
      </div>
    </QueryClientProvider>
  </ChakraProvider>
);
export default App;
